import { useState } from 'react';
import { ProductVariantColorViewModel, ProductVariantWeightViewModel } from '@/types/api';
import WeightDisplay from '@/features/pdp-components/weight-display';
import WeightVariant from '@/features/pdp-components/weight-variant';
import VariantsLayoutWrapper from './variants-layout-wrapper';
import { VariantContextType } from '../../context/types';
import { useVariantContextValues } from '../../context/use-variant-context-values';
interface Props {
  isCarousel: boolean;
  clickHandler: (color: ProductVariantWeightViewModel) => void;
  selectedColor: ProductVariantColorViewModel | undefined;
  selectedWeight: ProductVariantWeightViewModel | undefined;
  contextType: VariantContextType;
}
const WeightVariants = ({
  clickHandler,
  selectedColor,
  selectedWeight,
  isCarousel = false,
  contextType
}: Props) => {
  const [hoveredWeight, setHoveredWeight] = useState<ProductVariantWeightViewModel>();
  const {
    defaultWeight,
    hasWeightOptions,
    uniqueWeightVariants,
    allVariants,
    hasAtleastOneWeightUnit
  } = useVariantContextValues(contextType);
  const handleMouseEnter = (weight: ProductVariantWeightViewModel) => setHoveredWeight(weight);
  const handleMouseLeave = () => setHoveredWeight(undefined);
  const weightToDisplay = hoveredWeight || selectedWeight || defaultWeight;
  return <>
            {(!!weightToDisplay || hasWeightOptions) && <span className='text-body-14 text-text-darkGray lg:text-body-16'>
                    {hasAtleastOneWeightUnit ? 'وزن' : 'سایز'}:{' '}
                    {weightToDisplay && <WeightDisplay value={weightToDisplay?.value || 0} unit={weightToDisplay?.unit || ''} className='text-text-black' />}
                </span>}
            {hasWeightOptions && <VariantsLayoutWrapper isCarousel={isCarousel} spacing={12}>
                    {uniqueWeightVariants?.map(variant => {
        const weight = variant.weight;
        if (!weight?.value) return null;
        const isSelected = weight.value === selectedWeight?.value;
        let isSalable = variant.isSalable || false;
        if (selectedColor?.id) {
          isSalable = allVariants?.find(v => selectedColor?.id === v.color?.id && v.weight?.value === weight.value)?.isSalable || false;
        }
        return <WeightVariant className={isCarousel ? 'keen-slider__slide !w-fit min-w-fit justify-center' : ''} key={`${weight.value}-${weight.unit}`} handleMouseEnter={() => handleMouseEnter(weight)} handleMouseLeave={handleMouseLeave} handleClick={() => clickHandler(weight)} weight={weight} isSelected={isSelected} isSalable={isSalable} />;
      })}
                </VariantsLayoutWrapper>}
        </>;
};
export default WeightVariants;